import { render, staticRenderFns } from "./WhitelistModal.vue?vue&type=template&id=2362af70&scoped=true&"
import script from "./WhitelistModal.vue?vue&type=script&lang=js&"
export * from "./WhitelistModal.vue?vue&type=script&lang=js&"
import style0 from "./WhitelistModal.vue?vue&type=style&index=0&id=2362af70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362af70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2362af70')) {
      api.createRecord('2362af70', component.options)
    } else {
      api.reload('2362af70', component.options)
    }
    module.hot.accept("./WhitelistModal.vue?vue&type=template&id=2362af70&scoped=true&", function () {
      api.rerender('2362af70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/WhitelistModal.vue"
export default component.exports